if (!customElements.get('big-career-job')) {
  customElements.define('big-career-job', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.();
      const bar = this.querySelector('[data-big-leiste]');
      const content = this.querySelector('[data-big-job-content]');
      const buttons = [...this.querySelectorAll('[data-big-bewerben]')];
      if (!bar || !content || !buttons.length) return;
      const controller = new AbortController();
      const mobile = matchMedia('(max-width: 740px)');
      let frame = 0;
      const setVisible = visible => {
        bar.classList.toggle('ist-sichtbar', visible);
        bar.inert = !visible;
        bar.setAttribute('aria-hidden', String(!visible));
      };
      const update = () => {
        frame = 0;
        const viewport = window.visualViewport;
        const top = viewport?.offsetTop || 0;
        const bottom = top + (viewport?.height || window.innerHeight);
        const height = mobile.matches ? bar.getBoundingClientRect().height : 0;
        this.style.setProperty('--big-apply-height', `${height}px`);
        const area = content.getBoundingClientRect();
        const rects = buttons.map(button => button.getBoundingClientRect());
        const regularButtonVisible = rects.some(rect => rect.bottom > top && rect.top < bottom);
        const active = document.activeElement;
        const focus = active && active !== document.body && active.matches(':focus-visible') ? active : null;
        const focusRect = focus?.getBoundingClientRect();
        const focusOutside = focus && !this.contains(focus);
        const focusCovered = focusRect && !bar.contains(focus) && focusRect.bottom > bottom - height && focusRect.top < bottom;
        const keyboardOpen = viewport && viewport.height < window.innerHeight * 0.75;
        setVisible(Boolean(mobile.matches && area.top < bottom && area.bottom > top + height &&
          rects[0].bottom <= top && !regularButtonVisible && !focusOutside && !focusCovered && !keyboardOpen));
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      const options = {passive: true, signal: controller.signal};
      window.addEventListener('scroll', schedule, options);
      window.addEventListener('resize', schedule, options);
      document.addEventListener('focusin', schedule, options);
      document.addEventListener('focusout', schedule, options);
      window.visualViewport?.addEventListener('resize', schedule, options);
      window.visualViewport?.addEventListener('scroll', schedule, options);
      const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
      resize?.observe(bar);
      resize?.observe(content);
      this.cleanup = () => {
        controller.abort();
        resize?.disconnect();
        cancelAnimationFrame(frame);
        frame = 0;
        setVisible(false);
        this.style.removeProperty('--big-apply-height');
      };
      schedule();
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}
